// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CharToolbar.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * CharToolbar component
 */
import React from 'react';
import ReportPartToolbar from './Izenda.ReporPartToolbar';
import ChartMetrics from './Izenda.ChartMetrics';
import ChartDrilldownBreadcrumb from './Izenda.ChartDrilldownBreadcrumb';
import connect from 'share/enhancers/Izenda.Connect';
import { getOr, pick } from 'lodash/fp';
import actions from './Izenda.ChartToolbarActions';

export default connect(actions)(function ChartToolbar(props: any) {
  const isShowMetric = getOr(true, 'isShowMetric', props);
  const isShowBreadcrumb = getOr(true, 'isShowBreadcrumb', props);
  const { localization, hideGridPopup, showGridPreviewPopup } = props;
  const showToolbar = isShowMetric || !hideGridPopup;
  const breadCrumbProps = pick(
    ['reportPart', 'reportPartContent', 'onDrillDown', 'points', 'getPoints', 'className', 'hideAllLevel'],
    props
  );
  const chartMetricProps = pick(['reportPart', 'className'], props);

  return (
    <ReportPartToolbar>
      {/* breadcrumb - drilldown info */}
      {isShowBreadcrumb && (
        <ChartDrilldownBreadcrumb {...breadCrumbProps} className="izenda-ReportPartChartToolbar_leftSide" />
      )}

      {/* metric - list of values to show certain series */}
      {showToolbar && (
        <div className="izenda-ReportPartToolbar_rightSide u-posTopRight u-posAbsolute u_textRight">
          {!hideGridPopup && (
            <a className="izenda-GridPopupIcon" title={localization.getText('GRID_POPUP_TOOLTIP')}>
              <span className="icon-grid" onClick={showGridPreviewPopup} />
            </a>
          )}
          {isShowMetric && <ChartMetrics {...chartMetricProps} />}
        </div>
      )}
    </ReportPartToolbar>
  );
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ChartToolbar.js